
export default {
  props: {
    slice: { type: Object, default: Function },
  },

  data() {
    return {
      selected: null,
    }
  },

  computed: {
    safeToRenderMembers() {
      return this.slice.items
        .filter(
          (item) =>
            item &&
            item.team_member &&
            item.team_member.data &&
            item.team_member.data.portrait
        )
        .map((item) => item.team_member)
    },
  },

  created() {
    this.selected = this.$route.hash.replace('#', '')
  },

  methods: {
    toggleSelection(member) {
      if (this.selected === member) {
        this.selected = null
      } else {
        this.selected = member
        this.$router.push({ path: this.$route.path, hash: member })
      }
    },

    isSelected(member) {
      return this.selected === member
    },
  },
}
